import script from "./EducationModel.vue?vue&type=script&lang=ts&setup=true"
export * from "./EducationModel.vue?vue&type=script&lang=ts&setup=true"

import "./EducationModel.vue?vue&type=style&index=0&id=86a1e374&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86a1e374"]])

export default __exports__